import ContactList from '../components/contact/List.vue';
import ContactShow from '../components/contact/Show.vue';
import PairMethodSelection from '../components/contact/PairMethodSelection.vue';
import PairQRReader from '../components/contact/PairQRReader.vue';
import PairSuccess from '../components/contact/PairSuccess.vue';
import PairURL from '../components/contact/PairURL.vue';
import auth from '../middleware/auth';

export default [
    {
        name: 'ContactList',
        path: '/contacts',
        component: ContactList,
        props: ({params}) => {
            return {highlight: params.highlight};
        },
        children: [
            {
                name: 'ContactAdd',
                path: 'add',
                components: {modal: PairMethodSelection},
                meta: {
                    showModal: true,
                    middleware: [auth],
                    title: 'global.menu.contacts'
                }
            },
            {
                name: 'ContactAddQR',
                path: 'add-qr',
                components: {modal: PairQRReader},
                meta: {
                    showModal: true,
                    middleware: [auth],
                    title: 'global.menu.contacts'
                }
            },
            {
                name: 'ContactAdded',
                path: 'added',
                components: {modal: PairSuccess},
                meta: {
                    showModal: true,
                    middleware: [auth],
                    title: 'global.menu.contacts'
                }
            },
        ],
        meta: {
            middleware: [auth],
            title: 'global.menu.contacts'
        }
    },
    {
        name: 'ContactAddURL',
        path: '/contacts/add/:token',
        component: PairURL,
        meta: {
            middleware: [auth],
            title: 'global.menu.contacts'
        }
    },
    {
        name: 'ContactAddURLEmail',
        path: '/contacts/add/email/:token',
        component: PairURL,
        props: {
            autoAccept: true
        },
        meta: {
            middleware: [auth],
            title: 'global.menu.contacts'
        }
    },
    {
        name: 'ContactShow',
        path: '/contact/:id',
        component: ContactShow,
        meta: {
            middleware: [auth],
            title: 'global.menu.contacts'
        }
    }
];



// WEBPACK FOOTER //
// ./src/routes/contact.js